"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** Platform UI Components */
var InfiniteLoader_1 = require("@idp/ui-components/components/atoms/InfiniteLoader");
/** Stylesheets */
var styles = require("./CommonSpinner.scss");
var CommonSpinner = function () {
    return (React.createElement("div", null,
        React.createElement("div", { className: [styles.pageLevelSpinnerContainer].join(' ') },
            React.createElement("div", { className: styles.pageLevelGrayArea, "aria-hidden": "true" }, "\u00A0"),
            React.createElement("div", { className: styles.pageLevelSpinnerWrapper },
                React.createElement(InfiniteLoader_1.default, { "aria-label": "spinnerload" })))));
};
exports.default = CommonSpinner;
//# sourceMappingURL=CommonSpinner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CommonSpinner/CommonSpinner.js
// module id = 1483
// module chunks = 8